import type { FuneralCollectionConfig } from './categoryPageConfig';

/**
 * Serializable content for the dedicated funeral collection presentation.
 * The component intentionally owns only rendering and collection loading.
 */
export const FUNERAL_CONFIGS: Record<string, FuneralCollectionConfig> = {
  'bukiety-pogrzebowe': {
    handle: 'bukiety-pogrzebowe',
    breadcrumb: 'Bukiety pogrzebowe',
    seoTitle: 'Bukiety pogrzebowe — Lublin | Bukietowa',
    seoDescription: 'Bukiety pogrzebowe ze świeżych kwiatów, przygotowywane z szacunkiem przez florystów Bukietowej w Lublinie. Dostawa tego samego dnia.',
    h1Line1: "Bukiety pogrzebowe",
    h1Accent: "w Lublinie",
    description: "Kwiaty do pożegnania bliskiej osoby lub przekazania kondolencji. Wybierz kompozycję, a przy dostawie na uroczystość ustal z kwiaciarnią miejsce i termin przekazania.",
    breadcrumbs: [
      { label: 'Kompozycje pogrzebowe', href: '/kompozycje-pogrzebowe/' },
      { label: 'Bukiety pogrzebowe' },
    ],
  },
  'wience-pogrzebowe': {
    handle: 'wience-pogrzebowe',
    breadcrumb: 'Wieńce pogrzebowe',
    seoTitle: 'Wieńce pogrzebowe — Lublin | Bukietowa',
    seoDescription: 'Wieńce pogrzebowe wykonywane ze świeżych kwiatów przez florystów Bukietowej w Lublinie. Dostawa tego samego dnia.',
    h1Line1: "Wieńce pogrzebowe",
    h1Accent: "w Lublinie",
    description: "Wieniec od rodziny, przyjaciół lub współpracowników. Porównaj formę i kolorystykę, a przed zamówieniem potwierdź wielkość, sposób wykonania oraz możliwość dołączenia szarfy.",
    breadcrumbs: [
      { label: 'Kompozycje pogrzebowe', href: '/kompozycje-pogrzebowe/' },
      { label: 'Wieńce pogrzebowe' },
    ],
  },
  'wiazanki-pogrzebowe': {
    handle: 'wiazanki-pogrzebowe',
    breadcrumb: 'Wiązanki pogrzebowe',
    seoTitle: 'Wiązanki pogrzebowe — Lublin | Bukietowa',
    seoDescription: 'Wiązanki pogrzebowe ze świeżych kwiatów od florystów Bukietowej w Lublinie. Realizacja i dostawa tego samego dnia.',
    h1Line1: "Wiązanki pogrzebowe",
    h1Accent: "z dostawą w Lublinie",
    description: "Wybierz wiązankę jako osobisty wyraz pamięci i szacunku. Przyjrzyj się jej kształtowi oraz kwiatom w opisie produktu, a szczegóły doręczenia na ceremonię ustal przed zakupem.",
    breadcrumbs: [
      { label: 'Kompozycje pogrzebowe', href: '/kompozycje-pogrzebowe/' },
      { label: 'Wiązanki pogrzebowe' },
    ],
  },
  'sztuczne-kompozycje': {
    handle: 'sztuczne-kompozycje',
    breadcrumb: 'Sztuczne kompozycje',
    seoTitle: 'Sztuczne kompozycje pogrzebowe — Lublin | Bukietowa',
    seoDescription: 'Trwałe sztuczne kompozycje pogrzebowe od Bukietowej w Lublinie. Idealne na grób — nie więdną, zachowują piękno przez długi czas.',
    h1Line1: "Sztuczne kompozycje",
    h1Accent: "kwiatowe na grób",
    description: "Dekoracje ze sztucznych kwiatów do miejsca pamięci. Sprawdź materiały i wymiary konkretnej kompozycji; jej odporność na słońce, deszcz i mróz zależy od wykonania.",
    breadcrumbs: [
      { label: 'Kompozycje pogrzebowe', href: '/kompozycje-pogrzebowe/' },
      { label: 'Sztuczne kompozycje' },
    ],
  },
};